import Vue from 'vue'
import VueLodash from 'vue-lodash'
// lodash想要tree shking必须要这样使用路径单独引入

import map from 'lodash/map'
import cloneDeep from 'lodash/cloneDeep'
import sortBy from 'lodash/sortBy'
import compact from 'lodash/compact'
import isEqual from 'lodash/isEqual'
import isEmpty from 'lodash/isEmpty'
import uniqWith from 'lodash/uniqWith'
import dropRight from 'lodash/dropRight'
import pick from 'lodash/pick'

Vue.use(VueLodash, {
  name: 'lo',
  lodash: {
    map,
    cloneDeep,
    sortBy,
    compact,
    isEqual,
    uniqWith,
    dropRight,
    isEmpty,
    pick
  }
})
